import React, { memo, useEffect, useState } from 'react';
import {
    Card, CardBody, Row, Col, Button,
    // UncontrolledAlert, 
    ButtonToolbar, Spinner, Alert,
    Modal, ModalBody,
} from "reactstrap";
import DrawDropdown from './DrawDropdown';
import { MdArrowBack, MdVerticalAlignBottom } from "react-icons/md";
import { connect } from "react-redux";
import validate from "./validate";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderField } from '../../../../utils/renderfield';
import { Link } from "react-router-dom";
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderRadioButtonField from '../../../../shared/components/form/RadioButton';


const DisbursementRedraftForm = memo(({ reset, disbursementType, pristine, change, invalid, handleSubmit, submitting, csvFileValue, postDisbursement }) => {

    const [showModal, setShowModal] = useState(false);
    const [showMessage, setShowMessage] = useState("");
    const changeDisbursementType = (status) => {

    }

    const openMessage = (str) => {
        setShowMessage(str);
        setShowModal(true);
    }

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">
                            <Link to="/disbursement" id="link-all-users">
                                <MdArrowBack size={20} /> Back to Disbursement Table
                            </Link>
                        </h5>
                    </div>
                    <form className="form" onSubmit={handleSubmit}>
                        <Col lg={{ size: 8, offset: 3 }}>
                            <Row>
                                <Col lg="8">
                                    <h5 className="form__form-group-label">REDRAFT DISBURSEMENT - Enter disbursement details below.</h5>
                                    <br />
                                    <br />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="8">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label bold-text">Name of Disbursement</span>
                                        <div className="form__form-group-field">
                                            <Field
                                                id="nameOfDisbursement"
                                                name="nameOfDisbursement"
                                                component={renderField}
                                                type="text"
                                                placeholder=""
                                                required
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="8">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label bold-text">Paycode Amount</span>
                                        <div className="form__form-group-field">
                                            <Field
                                                id="amount"
                                                name="amount"
                                                component={renderField}
                                                type="number"
                                                required
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="8">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label bold-text">Number of Recipients</span>
                                        <div className="form__form-group-field">
                                            <Field
                                                id="noOfRecipients"
                                                name="noOfRecipients"
                                                component={renderField}
                                                type="number"
                                                required
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="8">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label bold-text">Created Date</span>
                                        <div className="form__form-group-field">
                                            <Field
                                                id="createdDate"
                                                name="createdDate"
                                                component={renderField}
                                                type="text"
                                                placeholder={new Date().toLocaleDateString()}
                                                disabled
                                                required
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="8">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label bold-text">Created By</span>
                                        <div className="form__form-group-field">
                                            <Field
                                                id="createdBy"
                                                name="createdBy"
                                                component={renderField}
                                                type="text"
                                                placeholder={'Ada'}
                                                disabled
                                                required
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="8">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label bold-text">Select Instant or scheduled Disbursement</span>
                                        <div className="form__form-group-field">
                                            <Field
                                                name="disbursementType"
                                                component={renderRadioButtonField}
                                                label="Instant"
                                                radioValue="INSTANT"
                                                defaultChecked
                                            />
                                            <Field
                                                name="disbursementType"
                                                component={renderRadioButtonField}
                                                label="Scheduled"
                                                radioValue="SCHEDULED"
                                            />

                                        </div>
                                    </div>
                                    {disbursementType === "SCHEDULED" && <div className="form__form-group">
                                        <div className="form__form-group-field">
                                            <Field
                                                id="scheduledDate"
                                                name="scheduledDate"
                                                component={renderField}
                                                type="date"
                                            />
                                        </div>
                                    </div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="8">
                                    <div className="randomiserflexcontainer randomiserspacebetween">
                                        <span className="form__form-group-label"></span>
                                        <span>
                                            <a target="blank" href={"https://mufasa-qa.interswitchng.com/p/verve-reward-v2/resources/files/raffle/templates/disbursement-file-template.csv"}>
                                                <MdVerticalAlignBottom />&nbsp;
                                                Download Disbursement Template to input details
                                                <br /><br />
                                            </a>
                                        </span>
                                    </div>
                                    <section>
                                        <Alert color="info" style={{ height: "5.5rem", border: "2px dotted #449dcf", }}>
                                            <div className="form__form-group" style={{ textAlign: "center" }}>
                                                <div className="form__form-group-field bold-text">
                                                    <Field
                                                        id="csv_file"
                                                        name="csv_file"
                                                        component={renderFileInputField}
                                                        anchorText="Drag and drop file here or browse"
                                                        accept=".csv"
                                                        required
                                                    />
                                                </div>
                                                {csvFileValue ? "" : <small>Accepted file format .CSV</small>}
                                            </div>
                                        </Alert>
                                    </section>
                                </Col>
                            </Row>
                            <ButtonToolbar className="form__button-toolbar">
                                <Button type="button" id="reset-form" onClick={reset} disabled={false}> {/*  || pristine || submitting */}
                                    Cancel
                                </Button>
                                <Button color="primary" id="submit-btn" type="button" onClick={() => openMessage("The document you uploaded will be replaced with the current document.")} disabled={false}> {/*  || submitting || invalid */}
                                    {postDisbursement.loading &&
                                        <span>
                                            <Spinner size="sm" color="default" />{" "}
                                        </span>
                                    }
                                    Save
                                </Button>
                            </ButtonToolbar>
                        </Col>
                    </form>
                    <Modal isOpen={showModal} centered={true}>
                        <ModalBody>
                            <Card>
                                <div className="form__form-group-label bold-text" style={{ marginTop: 6, height: 10, borderWidth: 0 }}>Save Draft</div>
                                <hr />
                                <div style={{ textAlign: "center", alignItems: "center" }}>
                                    <h5>{showMessage}</h5>
                                    <br /><br />
                                    <Button color="primary" type="button" id="reset-form" onClick={() => setShowModal(false)}>
                                        Done
                                    </Button>
                                </div>
                            </Card>
                        </ModalBody>
                    </Modal>
                </CardBody>
            </Card>
        </Col>
    );
});

const selector = formValueSelector("disbursement_form");
export default reduxForm({
    form: "disbursement_form",
    validate,
    enableReinitialize: true
})(
    connect((state) => ({
        postuser: state.postuser,
        permissions: state.permissions && state.permissions.response,
        csvFileValue: selector(state, "csv_file"),
        disbursementType: selector(state, 'disbursementType')
    }))(DisbursementRedraftForm)
);